import React from "react";
import { FormattedMessage } from "react-intl";
import mediaQueries from "~/components/mediaQueries";

interface IChangePlanOptionNameProps {
  viewerIsSubscribed: boolean;
  name: string;
}

export default function ChangePlanOptionName({ viewerIsSubscribed, name }: IChangePlanOptionNameProps) {
  return (
    <div
      css={mediaQueries({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: ["100%", "100%", "100%", "auto"],
        height: ["auto", "auto", "auto", "100%"],
        textAlign: "center",
        borderRight: ["none", "none", "none", "solid 1px #e3e3e3"],
        borderBottom: ["solid 1px #e3e3e3", "solid 1px #e3e3e3", "solid 1px #e3e3e3", "none"],
      })}
    >
      <div
        css={{
          display: "grid",
          gridRowGap: 5,
          padding: 20,
        }}
      >
        {viewerIsSubscribed && (
          <span
            css={{
              fontSize: 14,
              lineHeight: 1.33,
              fontWeight: 500,
              color: "#797979",
            }}
          >
            <FormattedMessage defaultMessage="Current Plan" id="Z3GpJF" />
          </span>
        )}

        <h3
          css={{
            margin: 0,
            fontSize: 19,
            fontWeight: 600,
            color: "#212121",
            lineHeight: 1.33,
          }}
        >
          {name}
        </h3>
      </div>
    </div>
  );
}
